/**
 * Grey suggestions one can take: in an empty field marked `data-suggest`, Tab writes the grey
 * placeholder in as its value and keeps the cursor there to edit it. Only for placeholders that
 * are a real value („1/8 l 6,50; 1/4 l 12,50“), not for examples („z. B. Regal D“).
 */
export function installSuggestions(doc: Document = document) {
  doc.addEventListener("keydown", (e) => {
    const el = e.target;
    if (e.key !== "Tab" || e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return;
    if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) || !el.hasAttribute("data-suggest")) return;
    if (el.value !== "" || el.placeholder === "") return;
    e.preventDefault();
    // Through the native setter, so React's controlled field sees the change.
    const proto = el instanceof HTMLInputElement ? HTMLInputElement.prototype : HTMLTextAreaElement.prototype;
    Object.getOwnPropertyDescriptor(proto, "value")!.set!.call(el, el.placeholder);
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.setSelectionRange(el.value.length, el.value.length);
  });
}
